import { Components, Theme } from "@mui/material";

export const MuiMenu: Components<Omit<Theme, "MuiMenu">>["MuiMenu"] = {
  styleOverrides: {
    paper: {
      gap: "2px",
      borderRadius: "var(--radius-primary, 8px)",
      padding: "8px",
      boxShadow: `
        0px 24px 52px 0px #0000001A,
        0px 95px 95px 0px #00000017,
        0px 213px 128px 0px #0000000D,
        0px 378px 151px 0px #00000003,
        0px 591px 166px 0px #00000000,
        0px -2px 10px 0px #D0D0D01A
      `,
    },
  },
};
